@if (productLoading()) {
<atx-loader-overlay class="p-3" type="static"></atx-loader-overlay>
} @else if (selectCached()?.materials.length) {
<epc-preview-size-grid
  [scaleSets]="selectCached()?.availableScaleSets"
  [quantities]="sizesMerged()"
  [products]="materialsWithSizes()"
  [selectedScale]="selectCached()?.selectedScale"
  [differentMaterialDimensions]="differentMaterialDimensions()"
></epc-preview-size-grid>
} @else {
<p
  class="badge m-0 p-2"
  i18n="CBasket|No sizes preview message@@noSizesPreviewMessage"
>
  No preview available
</p>
}
